import { FormBaseType } from "@green0meter/api-client";

import { REPORT_PAGES } from "@constants";

export const BRSR_CONFIG = {
  formBaseType: FormBaseType.BRSR,
  welcomeBanner: {
    titleKey: "brsrhub.welcome",
    textKey: "brsrhub.welcomeText",
    color: "blue",
    icon: "accountant",
  },
  collectData: {
    titleKey: "brsrCollectionDataTitle",
    descriptionKey: "brsrCollectionDataDescription",
    color: "teal",
    icon: "data-gathering",
    buttonTextKey: "brsrCollectionDataButtonStart",
    noFormsTextKey: "collectData.noFormsCreated",
  },
  reports: {
    titleKey: "brsr.hub.reports.title",
    type: "brsr-reports",
    noReportsTextKey: "brsr.hub.reports.noReports",
    fillFormTextKey: "brsr.hub.reports.fillForm",
  },
  overview: {
    titleKey: "brsr.hub.overview.title",
    dashboardPath: "/brsr/dashboard",
    viewDashboardTextKey: "common.viewDashboard",
    reportPageId: REPORT_PAGES.BRSR,
  },
};
